import { useFormContext } from "contexts/FormContext";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import NormalView from "./NormalView";
import ItemHeader from "./ItemHeader";
import ItemTitle from "./ItemTitle";

const Item = ({ item }) => {
  // contexts
  const { formState } = useFormContext();

  // states
  const [sold, setSold] = useState(false);

  // effects
  useEffect(() => {
    const cartItem = formState.details.find((x) => x.item.id === item.id);
    setSold(cartItem);
  }, [formState.details]);

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="position-relative px-0">
          <ItemHeader item={item} />
        </Card.Header>
        <Card.Body>
          <Card.Title className="text-center" style={{ height: "50px" }}>
            <ItemTitle item={item} />
          </Card.Title>
          {<NormalView item={item} />}
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default Item;
